var map = {
	".": 42,
	"./": 42,
	"./App": 41,
	"./App.js": 41,
	"./App.test": 127,
	"./App.test.js": 127,
	"./Fruits": 76,
	"./Fruits.js": 76,
	"./Main": 77,
	"./Main.css": 170,
	"./Main.js": 77,
	"./Question": 74,
	"./Question.js": 74,
	"./Quiz": 50,
	"./Quiz.css": 83,
	"./Quiz.js": 50,
	"./Results": 72,
	"./Results.js": 72,
	"./Scoreboard": 73,
	"./Scoreboard.js": 73,
	"./Speech": 75,
	"./Speech.js": 75,
	"./images/apple.png": 492,
	"./images/apricot.png": 493,
	"./images/bac.jpg": 494,
	"./images/background.jpg": 495,
	"./images/banana.png": 496,
	"./images/cherry.png": 497,
	"./images/grapes.png": 498,
	"./images/kiwi.png": 499,
	"./images/litchi.png": 500,
	"./images/logo.png": 501,
	"./images/orange.png": 502,
	"./images/pear.png": 503,
	"./images/pineapple.png": 504,
	"./images/pomegranate.png": 505,
	"./images/result.gif": 506,
	"./images/strawberry.png": 507,
	"./images/watermelon.png": 508,
	"./index": 42,
	"./index.css": 122,
	"./index.js": 42,
	"./serviceWorker": 78,
	"./serviceWorker.js": 78,
	"./setupTests": 171,
	"./setupTests.js": 171,
	"./sounds/right.mp3": 112,
	"./sounds/welcome.wav": 114,
	"./sounds/wrong.mp3": 113
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 221;